module.exports = __webpack_public_path__ + "img/IMG_6689_L.03861f7c.webp";